/**
 * Available Menu IDs
 */
export enum MenuID {
  ADMIN = 'admin-sidebar',
  PUBLIC = 'public',
  DSO_EDIT = 'dso-edit'
}
